import React from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";
import { initAppTelemetry } from "./utils/telemetry";

const dsn = import.meta.env.VITE_SENTRY_DSN;
const enableSentry = import.meta.env.PROD && dsn;
if (enableSentry) {
  console.log('[Sentry] Initializing with DSN:', dsn?.replace(/@[^@]+$/, '@***'));
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE || "development",
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: false }),
    ],
    tracesSampleRate: 1.0,
    // Exclude Supabase URLs: Edge Functions gateway truncates Access-Control-Allow-Headers
    // on preflight, so sentry-trace/baggage cause CORS errors. See:
    // https://github.com/supabase/supabase/issues/41334
    tracePropagationTargets: [
      "localhost",
      /^https:\/\/(www\.)?mrscater\.com/,
      /^https:\/\/caterer\.mrscater\.com/,
      /^https:\/\/admin\.mrscater\.com/,
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    enableLogs: true,
  });
}

initAppTelemetry();

const container = document.getElementById("root");
const root = createRoot(container);

root.render(<App />);
